import { EBookingsFilters } from '@/constants/booking';

import { TRootState } from '../rootReducer';

export const upcomingTripSelector = (state: TRootState) => [
  ...(state.bookings.bookings[EBookingsFilters.UPCOMING]?.data || []),
];
